import { defineMessages } from 'react-intl';

const messages = defineMessages({
  firstLineColumnHeaders: {
    description: 'orderImportModal.firstLineColumnHeaders',
    defaultMessage: 'The first line of the file contains column headers',
    id: 'MlDO1r',
  },
  firstLineBlurb: {
    description: 'orderImportModal.firstLineBlurb',
    defaultMessage: 'Upload a CSV file to import orders into a manual store.',
    id: 'DK65pM',
  },
  secondLineBlurb: {
    description: 'Order import modal directions',
    defaultMessage:
      "You can create as many manual stores as you'd like (in <a>Account Settings > Selling Channels > Store Setup</a>) to help organize and segment your manual orders.",
    id: 'PgBoAS',
  },
  thirdLineBlurb: {
    description: 'Import order modal third line blurb',
    defaultMessage: 'Learn more about importing CSV Order files <a>here</a>.',
    id: '7HiltJ',
  },
  noManualStores: {
    description: 'orderImportModal.noManualStores',
    defaultMessage:
      'You dont have any manual stores. Please add a new manual store or activate an existing one by going to Selling Channels > { storeSetupLink }',
    id: '8dTArL',
  },
  modalTitle: {
    description: 'orderImportModal.title',
    defaultMessage: 'Import Orders',
    id: 'j88vR+',
  },
  importToStore: {
    defaultMessage: 'Import to store',
    id: 'oaoqV4',
    description: 'orderImportModal.importToStore',
  },
  fileToImport: {
    defaultMessage: 'File to import',
    id: 'C8L/oX',
    description: 'orderImportModal.fileToImport',
  },
  downladSampleCSVFile: {
    defaultMessage: 'Download a sample CSV File',
    id: 'O/AGsh',
    description: 'orderImportModal.downladSampleCSVFile',
  },
  selectFile: {
    defaultMessage: 'Select file',
    id: 'Zv3Vft',
    description: 'orderImportModal.selectFile',
  },
  fieldMappings: {
    defaultMessage: 'Field Mappings',
    id: 'nNfx1w',
    description: 'orderImportModal.fieldMappings',
  },
  createNewFieldMapping: {
    defaultMessage: 'Create a new field mapping',
    id: '6oJ8//',
    description: 'orderImportModal.createNewFieldMapping',
  },
  useSavedMapping: {
    defaultMessage: 'Use a saved mapping',
    id: 'UBknSF',
    description: 'orderImportModal.useSavedMapping',
  },
  savedMappings: {
    defaultMessage: 'Saved Mappings',
    id: 'UvtFe5',
    description: 'orderImportModal.savedMappings',
  },
  renameMapping: {
    defaultMessage: 'Rename Mapping',
    id: '9Rmr9W',
    description: 'orderImportModal.renameMapping',
  },
  deleteMapping: {
    defaultMessage: 'Delete Mapping',
    id: 'GfVS91',
    description: 'orderImportModal.deleteMapping',
  },
  cancelBtn: {
    defaultMessage: 'Cancel',
    id: 'VI6+Cf',
    description: 'orderImportModal.cancel',
  },
  uploadBtn: {
    defaultMessage: 'Upload',
    id: 'QvUArq',
    description: 'orderImportModal.upload',
  },
  pleaseSelect: {
    defaultMessage: 'Please select a .CSV or .TXT file',
    id: '7S5UPS',
    description: 'orderImportModal.pleaseSelect',
  },
  importInProgress: {
    defaultMessage: '{storeName} - import in progress',
    id: '7uNy7g',
    description: 'store is disabled because an import is already in progress',
  },
  selectStore: {
    defaultMessage: 'Select Store',
    id: 'O6g10b',
    description: 'default empty option for store drop down',
  },
});

export default messages;
